import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ProductComponent } from '../product.component';

@Component({
  selector: 'app-highlighted-text',
  templateUrl: './highlighted-text.component.html',
  styleUrls: ['./highlighted-text.component.scss']
})
export class HighlightedTextComponent implements OnInit {

  id: number;
  link: string;
  country: string;
  language: string;
  highlightedTexts: any = [];

  constructor(
    private route: ActivatedRoute,
    private productComponent: ProductComponent
  ) { }

  getProduct(){
    this.highlightedTexts = this.productComponent.product[0].highlightedText;
  }

  ngOnInit(): void {
    this.route.params
      .subscribe(
        (params: Params) => {
          this.id = +params['id'];
          this.link = params['link'];
          this.country = params['country'];
          this.language = params['language'];
          this. getProduct();
      }
    );
  }
}
